import { RegistryManager } from "./registerManager";

export function asEntity() {
    return function (target: any) {
        RegistryManager.register(target.className(), target, 'entities');
    };
}